import React,{useState} from 'react';
import { AutoComplete } from 'primereact/autocomplete';

function SearchComponent({ data, searchFields, placeholder, onSelect, label }) {
    const [filteredData, setFilteredData] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [inputText, setInputText] = useState('');
  
    const search = (event) => {
      const query = event.query.trim();
    if (!query.length) {
      setFilteredData([...data]);
      return;
    }
      setTimeout(() => {
        let _filteredData;
  
        if (!event.query.trim().length) {
          _filteredData = [...data];
        } else {
          const regex = new RegExp(`${event.query}`, "gi");
          _filteredData = data
            .filter((item) =>
              searchFields.some((field) =>
                item[field]?.toString().toLowerCase().match(regex)
              )
            )
            .map((item) => ({
              label: searchFields
                .map((field) => item[field] || "")
                .filter(Boolean)
                .join(" "),
              value: item,
            }));
        }
        setFilteredData(_filteredData);
      }, 250);
    };
    const handleChange = (e) => {
    setInputText(e.value);      // Always update input text
    setSelectedItem(null);      // Clear selection on manual input
    onSelect(null);             // Optional: notify parent it's not selected
  };

  const handleSelect = (e) => {
    setSelectedItem(e.value);            // Store selected item
    setInputText(e.value.label);         // Set input to selected label
    onSelect(e.value);                   // Send selected value to parent
  };
    const handleBlur = () => {
    if (!selectedItem && inputText.trim()) {
      const fallbackValue = {
        label: inputText.trim(),
        value: { user_id: null, full_name: inputText.trim() }, // fallback object
      };
      setSelectedItem(fallbackValue); // update internal value
      onSelect(fallbackValue);        // notify parent with free text
    }
  };
  return (
    <div className="search-component">
      {label ? <label className="d-block">{label}</label> : null}
      <AutoComplete
        field="label"
        value={inputText}
        suggestions={filteredData}
        
        completeMethod={search}
        onChange={handleChange}
        onSelect={handleSelect}
        onBlur={handleBlur}
        placeholder={placeholder}
        className="custom-autocomplete"
      />
    </div>
  )
}

export default SearchComponent